/* @flow */

export const DEFAULT_NATIVE_LANGUAGE_CODE: string = 'en';
export const DEFAULT_TARGET_LANGUAGE_CODE: string = 'th';
